import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

const apiPrefix = window.location.hostname === 'localhost' ? '' : '/api';
const get = (url) => axios.get(`${apiPrefix}${url}`, { withCredentials: true }).then(r => r.data);

export const useBriefings = () => useQuery({
    queryKey: ['briefings'],
    queryFn: () => get('/readAllBriefings').then(d => {
        const list = d.briefings || [];
        list.sort((a, b) => a.id - b.id);
        return list;
    }),
});

export const useBriefing = (id) => useQuery({
    queryKey: ['briefing', id],
    queryFn: () => get(`/readBriefing/${id}`),
    enabled: !!id,
});

export const useBriefingRuns = (id) => useQuery({
    queryKey: ['briefingRuns', id],
    queryFn: () => get(`/briefingRuns/${id}`),
    enabled: !!id,
});

export const useCreateBriefing = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.post(`${apiPrefix}/createBriefing`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['briefings'] }),
    });
};

export const useUpdateBriefing = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.post(`${apiPrefix}/updateBriefing`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['briefings'] }),
    });
};

export const useToggleBriefing = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.post(`${apiPrefix}/toggleBriefing`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['briefings'] }),
    });
};

export const useDeleteBriefing = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.post(`${apiPrefix}/deleteBriefing`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['briefings'] }),
    });
};
